import React, {useState,useEffect} from "react";
import ImageWithBasePath from "../../../../core/img";
import { Link } from "react-router-dom";
import ReactApexChart from "react-apexcharts";
import { all_routes } from "../../../router/all_routes";
/* -- biz9 import start -- */
import {Toaster} from 'react-hot-toast';
//import Authentication from '../authentication';
//import AlertMessage from '../alertMessage';
const Dashboard_User_Support = () => {
  const [chartOptions] = useState<any>({
    chart: {
      height: 290,
      type: "bar",
      toolbar: {
        show: false,
      },
    },
    series: [{
      data: [510, 320, 440, 600, 450, 150, 580, 190, 430, 290, 190, 290],
      name: 'Revenue'
    },
    {
      name: 'Withdrawn',
      data: [290, 120, 280, 190, 290, 290, 290, 110, 120, 130, 290, 120]
    },
  ],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "80%",
        borderRadius: 5,
        endingShape: "rounded",
      },
    },
    colors: ["#FF781A", "#45505C"],
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "May",
        "Mar",
        "Jun",
        "July",
        "Aug",
        "Apr",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      labels: {
        style: {
          colors: "#5D6772",
          fontSize: "14px",
        },
      },
    },
    yaxis: {
      min: 0,
      max: 600,
      labels: {
        offsetX: -15,
        style: {
          colors: "#5D6772",
          fontSize: "13px",
        },
      },
    },
    grid: {
      borderColor: "#E2E4E6",
      strokeDashArray: 5,
      padding: {
        left: -8,
        right: -15,
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val: any) {
          return `${val}%`;
        },
      },
    },
  })
  return (
    <>
      {/* Page Content */}
      <div className="page-wrapper">
        <div className="page-content content pb-0">
          <div className="main-title mb-4">
            <h4>Dashboard</h4>
          </div>
          {/* status */}
          <div className="row status-info">
            <div className="col-lg-3 col-md-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <p className="mb-1">Active AppZ</p>
                      <h6 className="mb-1">{"0"}</h6>
                    </div>
                    <span className="bg-primary-transparent status-icon">
                      <i className="ti ti-arrows-maximize" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <p className="mb-1">Pending AppZ</p>
                      <h6 className="mb-1">{"0"}</h6>
                    </div>
                    <span className="bg-success-transparent status-icon">
                      <i className="ti ti-circle-check" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* status */}
          {/* order */}
          <div className="row">
            <div className="col-xl-8 col-md-9 d-flex">
              <div className="card dashboard-card flex-fill w-100">
                <div className="card-header">
                  <div className="gig-card-head">
                    <h5 className="mb-0">My Orders</h5>
                  </div>
                  {/*
                  <Link to={""} className="view-link mb-0">
                    View All
                  </Link>
                  */}
                </div>
                <div className="card-body p-0">
                  <div className="table-responsive card-table">
                    <table className="table">
                      <tbody>

                        <tr>
                          <td>
                            <div className="d-flex align-items-center">
                              <div className="table-img">
                                <Link to="#">
                                  <ImageWithBasePath
                                    src="assets/img/gigs/gigs-07.jpg"
                                    className="img-fluid rounded-pill"
                                    alt="img"
                                  />
                                </Link>
                              </div>
                              <div className="recent-payment">
                                <h6>
                                  <Link to="#">
                                    I will do creating and promoting video...
                                  </Link>
                                </h6>
                                <ul>
                                  <li>Delivery Date: 11 Jan 2025</li>
                                  <li>
                                    Buyer :{" "}
                                    <span className="text-dark">Jones</span>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </td>
                          <td className="text-end">
                            <span className="badge badge-pink-transparent">
                              New
                            </span>
                          </td>
                          <td className="text-end amount-info">
                            <h6 className="mb-0">$1400</h6>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <div className="d-flex align-items-center">
                              <div className="table-img">
                                <Link to="#">
                                  <ImageWithBasePath
                                    src="assets/img/gigs/gigs-06.jpg"
                                    className="img-fluid rounded-pill"
                                    alt="img"
                                  />
                                </Link>
                              </div>
                              <div className="recent-payment">
                                <h6>
                                  <Link to="#">
                                    I will do integrating AR elements into...
                                  </Link>
                                </h6>
                                <ul>
                                  <li>Delivery Date: 07 Jan 2025</li>
                                  <li>
                                    Buyer :{" "}
                                    <span className="text-dark">Anderson</span>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </td>
                          <td className="text-end">
                            <span className="badge badge-success-transparent">
                              Completed
                            </span>
                          </td>
                          <td className="text-end amount-info">
                            <h6 className="mb-0">$4780</h6>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            </div>
          {/* order */}

           <div className="row">
            <div className="col-xl-8 col-md-6 d-flex">
              <div className="card recent-payment-card flex-fill w-100">
                <div className="card-header d-flex align-items-center justify-content-between">
                  <div className="gig-card-head">
                    <h5 className="mb-0">Recent Payments</h5>
                  </div>
                  <Link to={""} className="view-link mb-0">
                    View All
                  </Link>
                </div>
                <div className="card-body p-0">
                  <div className="table-responsive card-table">
                    <table className="table">
                      <tbody>
                        <tr>
                          <td>
                            <div className="recent-payment">
                              <h6>
                                <Link to="#">
                                  I will create a chatbot to change leads..
                                </Link>
                              </h6>
                              <p>
                                Id : #232 <span>|</span> Order Date: 11 Jan 2025
                              </p>
                            </div>
                          </td>
                          <td className="text-end">
                            <span className="badge badge-success-transparent">
                              <i className="ti ti-point-filled me-1" />
                              Recieved
                            </span>
                          </td>
                          <td className="text-end amount-info w-25">
                            <h6 className="mb-0">+$500</h6>
                            <Link
                              to="#"
                              className="btn btn-primary btn-lg py-1"
                              data-bs-toggle="modal"
                              data-bs-target="#transaction_details"
                            >
                              View
                            </Link>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className="recent-payment">
                              <h6>
                                <Link to="#">
                                  I will do english or german transcript of
                                  any..
                                </Link>
                              </h6>
                              <p>
                                Id : #231 <span>|</span> Order Date: 10 Jan 2025
                              </p>
                            </div>
                          </td>
                          <td className="text-end">
                            <span className="badge badge-success-transparent">
                              <i className="ti ti-point-filled me-1" />
                              Recieved
                            </span>
                          </td>
                          <td className="text-end amount-info w-25">
                            <h6 className="mb-0">+$500</h6>
                            <Link
                              to="#"
                              className="btn btn-primary btn-lg py-1"
                              data-bs-toggle="modal"
                              data-bs-target="#transaction_details"
                            >
                              View
                            </Link>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className="recent-payment">
                              <h6>
                                <Link to="#">
                                  I will do professional lifestyle and product
                                  ph..
                                </Link>
                              </h6>
                              <p>
                                Id : #230 <span>|</span> Order Date: 09 Jan 2025
                              </p>
                            </div>
                          </td>
                          <td className="text-end">
                            <span className="badge badge-success-transparent">
                              <i className="ti ti-point-filled me-1" />
                              Recieved
                            </span>
                          </td>
                          <td className="text-end amount-info w-25">
                            <h6 className="mb-0">+$7800</h6>
                            <Link
                              to="#"
                              className="btn btn-primary btn-lg py-1"
                              data-bs-toggle="modal"
                              data-bs-target="#transaction_details"
                            >
                              View
                            </Link>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className="recent-payment">
                              <h6>
                                <Link to="#">
                                  I will develop openai, dall, chat gpt app
                                  for...
                                </Link>
                              </h6>
                              <p>
                                Id : #229 <span>|</span> Order Date: 08 Jan 2025
                              </p>
                            </div>
                          </td>
                          <td className="text-end">
                            <span className="badge badge-success-transparent">
                              <i className="ti ti-point-filled me-1" />
                              Recieved
                            </span>
                          </td>
                          <td className="text-end amount-info w-25">
                            <h6 className="mb-0">+$7400</h6>
                            <Link
                              to="#"
                              className="btn btn-primary btn-lg py-1"
                              data-bs-toggle="modal"
                              data-bs-target="#transaction_details"
                            >
                              View
                            </Link>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className="recent-payment">
                              <h6>
                                <Link to="#">
                                  I will develop Website for Ecommerce
                                </Link>
                              </h6>
                              <p>
                                Id : #414 <span>|</span> Order Date: 07 Jan 2025
                              </p>
                            </div>
                          </td>
                          <td className="text-end">
                            <span className="badge badge-success-transparent">
                              <i className="ti ti-point-filled me-1" />
                              Recieved
                            </span>
                          </td>
                          <td className="text-end amount-info w-25">
                            <h6 className="mb-0">+$1452</h6>
                            <Link
                              to="#"
                              className="btn btn-primary btn-lg py-1"
                              data-bs-toggle="modal"
                              data-bs-target="#transaction_details"
                            >
                              View
                            </Link>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-md-6 d-flex">
              <div className="card recent-payment-card flex-fill w-100">
                <div className="card-header d-flex align-items-center justify-content-between">
                  <div className="gig-card-head">
                    <h5 className="mb-0">Recent Notifications</h5>
                  </div>
                  <Link
                    to={""}
                    className="view-link mb-0"
                  >
                    View All
                  </Link>
                </div>
                <div className="card-body p-0">
                  <div className="table-responsive card-table">
                    <table className="table">
                      <tbody>
                        <tr>
                          <td>
                            <div className="recent-payment">
                              <h6>
                                <Link to="#">Your Password Changed</Link>
                              </h6>
                              <p>54 Min Ago</p>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className="recent-payment">
                              <h6>
                                <Link to="#">Payment Settings Updated</Link>
                              </h6>
                              <p>1 Hour Ago</p>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className="recent-payment">
                              <h6>
                                <Link to="#">
                                  Purchased Gigs “I will do professional..”
                                </Link>
                              </h6>
                              <p>1 Day Ago</p>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className="recent-payment">
                              <h6>
                                <Link to="#">
                                  Added New Gig “I will do english”.
                                </Link>
                              </h6>
                              <p>15 Min Ago</p>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className="recent-payment">
                              <h6>
                                <Link to="#">Profile Updated</Link>
                              </h6>
                              <p>1 Day Ago</p>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Content */}
      {/* Withdraw */}
      <div
        className="modal new-modal fade"
        id="withdraw"
        data-keyboard="false"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Withdraw Payment</h5>
              <button
                type="button"
                className="close-btn"
                data-bs-dismiss="modal"
              >
                <span>×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="amt-wrap">
                    <div className="form-wrap">
                      <label className="form-label">
                        Enter Amount ($)
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <input type="text" className="form-control" />
                    </div>
                    <ul className="amt-list">
                      <li>Or</li>
                      <li>
                        <Link to="#" className="vary-amt">
                          $50
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="vary-amt">
                          $100
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="vary-amt">
                          $150
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="buyer-method">
                    <h6>Select Payment Gateway *</h6>
                    <label className="custom_radio">
                      <input type="radio" name="payment" />
                      <span className="checkmark" />
                      Paypal
                    </label>
                    <label className="custom_radio">
                      <input type="radio" name="payment" />
                      <span className="checkmark" />
                      Stripe
                    </label>
                  </div>
                  <div className="form-wrap form-item">
                    <label className="form-label">
                      Email<span className="text-danger ms-1">*</span>
                    </label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="form-wrap form-item">
                    <label className="form-label">
                      Password<span className="text-danger ms-1">*</span>
                    </label>
                    <input type="text" className="form-control" />
                  </div>
                </div>
                <div className="col-md-12">
                  <Link
                    to="#"
                    data-bs-toggle="modal"
                    data-bs-target="#success_credit"
                    data-bs-dismiss="modal"
                    className="btn btn-primary w-100"
                  >
                    Withdraw
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Withdraw */}
      {/* Transaction details  */}
      <div
        className="modal new-modal fade"
        id="transaction_details"
        data-keyboard="false"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-item-center">
                <h5 className="modal-title me-2">Transaction details </h5>
                <span className="badge badge-pink-transparent">Completed</span>
              </div>
              <button
                type="button"
                className="close-btn"
                data-bs-dismiss="modal"
              >
                <span>×</span>
              </button>
            </div>
            <div className="modal-body service-modal">
              <div className="sumary-widget">
                <div className="summary-info">
                  <h6 className="mb-1"> Transaction ID</h6>
                  <p> #TXN-20250321-00123462 </p>
                </div>
                <div className="summary-info">
                  <h6 className="mb-1"> Transaction Type </h6>
                  <p> Purchase </p>
                </div>
                <div className="summary-info">
                  <h6 className="mb-1"> Amount</h6>
                  <p> $320 </p>
                </div>
                <div className="summary-info">
                  <h6 className="mb-1"> Currency</h6>
                  <p> USD </p>
                </div>
                <div className="summary-info">
                  <h6 className="mb-1"> Processing Fee</h6>
                  <p> $20 </p>
                </div>
                <div className="summary-info">
                  <h6 className="mb-1"> Payment Method</h6>
                  <p> Credit Card </p>
                </div>
                <div className="summary-info mb-0">
                  <h6 className="mb-1"> Sender</h6>
                  <p> John Doe </p>
                </div>
                <div className="summary-info mb-0">
                  <h6 className="mb-1"> Receiver</h6>
                  <p> Jane Smith </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Transaction details */}
    </>
  );
};

export default Dashboard_User_Support;
